import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { BarraLateral } from './BarraLateral';
import { BarraSuperior } from './BarraSuperior';
export function AppLayout() {
  const [barraVisible, setBarraVisible] = useState(true);
  return <div className="min-h-screen w-full bg-gris-50" data-id="element-826" data-mp="1riit8e068hqf">
      <BarraLateral colapsada={!barraVisible} data-id="element-827" data-mp="1mi4hakvg8nn4" />
      <div className={`transition-[padding] duration-200 ease-out ${barraVisible ? 'pl-60' : 'pl-16'}`} data-id="element-828" data-mp="1mjfl2kow9ve8">
        <BarraSuperior barraVisible={barraVisible} onAlternarBarra={() => setBarraVisible(v => !v)} data-id="element-829" data-mp="1dp1agvfb791g" />
        <main className="px-6 py-6" data-id="element-830" data-mp="18p526jzkwvg3">
          <Outlet data-id="element-831" data-mp="18q7xr57ujm2c" />
        </main>
      </div>
    </div>;
}
export function EncabezadoPagina({
  titulo,
  descripcion,
  acciones
}: {
  titulo: string;
  descripcion?: string;
  acciones?: React.ReactNode;
}) {
  return <div className="mb-5 flex flex-wrap items-end justify-between gap-4" data-id="element-832" data-mp="uq5fhhvmmqmk">
      <div data-id="element-833" data-mp="uqynsna8ho6t">
        <h1 className="text-xl font-semibold text-marino-900" data-id="element-834" data-mp="usja5pmea0tl">{titulo}</h1>
        {descripcion && <p className="mt-1 text-sm text-gris-500" data-id="element-835" data-mp="1f0av2z1om1zm">{descripcion}</p>}
      </div>
      {acciones && <div className="flex items-center gap-2" data-id="element-836" data-mp="1juf2tkirue1r">{acciones}</div>}
    </div>;
}